<template>
    <div class="page-container" v-if="pageNumber > 1">
        <a @click="getNewPage(1)" :class="{ disabled: current == 1 }">|&lt;&lt;</a>
        <a @click="getNewPage(current - 1)" :class="{ disabled: current == 1 }">&lt;&lt;</a>
        <a @click="getNewPage(n)" v-for="(n, i) in getArray" :key="i" :class="{ active: current == n }">{{ n }}</a>
        <a @click="getNewPage(current + 1)" :class="{ disabled: current == pageNumber }">&gt;&gt;</a>
        <a @click="getNewPage(pageNumber)" :class="{ disabled: current == pageNumber }">&gt;&gt;|</a>
    </div>
</template>

<script>
export default {
    props: {
        current: {
            type: Number,
            default: 1
        },
        total: {
            type: Number,
            default: 1000
        },
        limit: {
            type: Number,
            default: 10
        },
        visibleNumber: {
            type: Number,
            default: 10
        }
    },
    computed: {
        pageNumber() {
            return Math.ceil(this.total / this.limit)
        },
        min() {
            let minNumber = this.current - Math.floor(this.visibleNumber / 2)
            if (minNumber < 1) {
                minNumber = 1
            }
            return minNumber
        },
        max() {
            let maxNumber = this.current + Math.ceil(this.visibleNumber / 2 - 1);
            if (maxNumber > this.pageNumber) {
                maxNumber = this.pageNumber
            }
            return maxNumber
        },
        getArray() {
            let pageArray = []
            for (let i = 0; i <= this.max - this.min; i++) {
                pageArray.push(this.min + i)
            }
            return pageArray
        }
    },
    methods: {
        getNewPage(newpage) {
            if (newpage < 1) {
                newpage = 1
            }
            if (newpage > this.pageNumber) {
                newpage = this.pageNumber
            }
            if (newpage == this.current) {
                return
            }
            this.$emit('pageChange', newpage)
        }
    }
}
</script>

<style lang="less" scoped>
@import url(../../type/reset.less);
.page-container {

    a {
        cursor: pointer;
        .unselected {
            display: none
        }

        color: @primary;
        margin: 0 3px;

        &.disabled {
            color: @lightWords;
            cursor: not-allowed;
        }

        &.active {
            color: @dark;
            font-weight: bold;
            cursor: text;
        }

        &:hover {
            color: #000;
        }
    }
}
</style>